import React, { FC, useMemo } from "react";
import { Pressable, View } from "react-native";
import { InfoBox } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import "@lookiero/sty-psp-ui";
import { useScreenSize, Text } from "@lookiero/sty-psp-ui";
import { CheckoutItemStatus } from "../../../../../../domain/checkoutItem/model/checkoutItem";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { style as customerDecissionBannerStyle } from "./CustomerDecissionBanner.style";

type CustomerDecissionBannerStatus = Exclude<CheckoutItemStatus, CheckoutItemStatus.INITIAL>;

const i18nMessageForCheckoutItemStatus: Record<CustomerDecissionBannerStatus, string> = {
  [CheckoutItemStatus.KEPT]: I18nMessages.ITEM_BANNER_CUSTOMER_KEPT_DECISSION,
  [CheckoutItemStatus.REPLACED]: I18nMessages.ITEM_BANNER_CUSTOMER_REPLACED_DECISSION,
  [CheckoutItemStatus.RETURNED]: I18nMessages.ITEM_BANNER_CUSTOMER_RETURNED_DECISSION,
};

interface CustomerDecissionBannerProps {
  readonly checkoutItemStatus: CustomerDecissionBannerStatus;
  readonly onPress: () => void;
}
const CustomerDecissionBanner: FC<CustomerDecissionBannerProps> = ({ checkoutItemStatus, onPress }) => {
  const decissionText = useI18nMessage({ domain: DOMAIN, id: i18nMessageForCheckoutItemStatus[checkoutItemStatus] });
  const bannerButtonText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.ITEM_BANNER_BUTTON });

  const screenSize = useScreenSize();
  const isSmallScreen = screenSize === "S";

  const style = useMemo(() => customerDecissionBannerStyle(), []);

  return (
    <View style={[style.container, isSmallScreen ? style.smallContainer : null]}>
      <InfoBox text={decissionText}>
        <Pressable testID="customer-decission-banner" onPress={onPress}>
          <Text level={isSmallScreen ? 2 : 1} style={style.underlinedText} variant="detail">
            {bannerButtonText}
          </Text>
        </Pressable>
      </InfoBox>
    </View>
  );
};

export type { CustomerDecissionBannerStatus };
export { CustomerDecissionBanner };
